import * as React from "react";

interface AuthLayoutProps {
  children: React.ReactNode;
  leftContent?: React.ReactNode;
}

export function AuthLayout({ children, leftContent }: AuthLayoutProps) {
  return (
    <div className="h-screen flex">
      {/* Left Side - Branding/Visual */}
      <div className="hidden lg:flex lg:w-1/2 bg-white p-12 flex-col justify-center items-center relative">
        <div className="relative z-10 max-w-md flex flex-col items-center">
          {leftContent || (
            <img
              src="https://orari.or.id/wp-content/uploads/2021/12/orari-png24-133x300-1.png"
              alt="ORARI Logo"
              className="max-w-full h-auto"
            />
          )}
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-gray-100 relative overflow-hidden">
        <div className="w-full max-w-md relative z-10">
          {children}
        </div>
      </div>
    </div>
  );
}
